import { render, staticRenderFns } from "./UnapprovedProducts.vue?vue&type=template&id=552a2f80&scoped=true&"
import script from "./UnapprovedProducts.vue?vue&type=script&lang=js&"
export * from "./UnapprovedProducts.vue?vue&type=script&lang=js&"
import style0 from "./UnapprovedProducts.vue?vue&type=style&index=0&id=552a2f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a2f80",
  null
  
)

export default component.exports